/* cc-fixes.js – Cocochoco fixes 2026-10-07 (cart add-on, cart recommendations, tab video lazy-play).
   Loaded with defer from layout/theme.liquid. Remove the <script> tag to undo. */
(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------- Cart drawer add-on: "Lägg till" ---------- */
  function addOnClick(event) {
    var btn = event.target.closest('[data-cc-addon-add]');
    if (!btn) return;
    event.preventDefault();
    var drawer = document.querySelector('cart-drawer');
    var variantId = parseInt(btn.getAttribute('data-cc-addon-add'), 10);
    if (!variantId) return;
    btn.setAttribute('aria-busy', 'true');
    var oldMsg = (btn.closest('.cc-addon__card') || btn.parentNode).querySelector('.cc-addon__error');
    if (oldMsg) oldMsg.remove();
    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().catch(function () { return { status: r.status || 500 }; }).then(function (state) {
          if (!r.ok && !state.status) state.status = r.status;
          return state;
        });
      })
      .then(function (state) {
        if (state.status) {
          showError(btn, state.description || state.message);
          return;
        }
        if (drawer && typeof drawer.renderContents === 'function' && state.sections) {
          drawer.renderContents(state);
        } else {
          window.location.href = root + 'cart';
        }
      })
      .catch(function () { showError(btn); });
  }
  /* Short Swedish error inside the add-on card; the button is enabled again so the customer can retry. */
  function showError(btn, detail) {
    btn.removeAttribute('aria-busy');
    var card = btn.closest('.cc-addon__card') || btn.parentNode;
    var msg = card.querySelector('.cc-addon__error');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'cc-addon__error';
      msg.setAttribute('role', 'alert');
      card.appendChild(msg);
    }
    msg.textContent = 'Kunde inte lägga till produkten. Försök igen.' + (detail && typeof detail === 'string' && detail.length < 120 ? ' (' + detail + ')' : '');
  }
  document.addEventListener('click', addOnClick);

  /* ---------- Cart drawer recommendations (complementary, then related) ---------- */
  function loadRecs(box) {
    if (!box || box.getAttribute('data-loaded')) return;
    box.setAttribute('data-loaded', '1');
    var pid = box.getAttribute('data-product-id');
    if (!pid) return;
    var exclude = (box.getAttribute('data-exclude') || '').split(',');
    var intents = ['complementary', 'related'];

    function tryIntent(i) {
      if (i >= intents.length) return;
      var url = root + 'recommendations/products?section_id=cc-cart-recs&limit=4&intent=' + intents[i] + '&product_id=' + pid;
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html || '', 'text/html');
          var cards = Array.prototype.slice.call(doc.querySelectorAll('.cc-addon__card'));
          var pick = cards.filter(function (c) { return exclude.indexOf(c.getAttribute('data-product-id')) === -1; })[0];
          if (!pick) return tryIntent(i + 1);
          var list = box.querySelector('[data-cc-addon-list]');
          if (!list) return;
          list.innerHTML = '';
          list.appendChild(pick);
          box.hidden = false;
        })
        .catch(function () {});
    }
    tryIntent(0);
  }
  function scanRecs() {
    document.querySelectorAll('[data-cc-recs]:not([data-loaded])').forEach(loadRecs);
  }
  document.addEventListener('DOMContentLoaded', function () {
    scanRecs();
    var drawer = document.querySelector('cart-drawer');
    if (drawer && window.MutationObserver) {
      new MutationObserver(scanRecs).observe(drawer, { childList: true, subtree: true });
    }
  });

  /* ---------- Product tab video: load and play only when visible ---------- */
  document.addEventListener('DOMContentLoaded', function () {
    var vids = document.querySelectorAll('video[data-cc-lazy-play]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) {
      vids.forEach(function (v) { v.play && v.play().catch(function () {}); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        var v = e.target;
        if (e.isIntersecting) {
          if (v.preload !== 'auto') v.preload = 'auto';
          var p = v.play();
          if (p && p.catch) p.catch(function () {});
        } else if (!v.paused) {
          v.pause();
        }
      });
    }, { rootMargin: '200px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  });

  /* ---------- Round 2: product video at the top of the gallery ---------- */
  /* The poster image shows first. After the page has loaded, the video file is attached and plays
     muted, inline and looped while it is on screen; it pauses when scrolled away. "Ljud på" turns the
     sound on (only after a tap, never automatically). */
  function initTopVideo() {
    var vids = document.querySelectorAll('video[data-cc-top-video]');
    if (!vids.length) return;
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var saveData = navigator.connection && navigator.connection.saveData;
    vids.forEach(function (v) {
      var box = v.closest('.cc-gvideo');
      var snd = box && box.querySelector('[data-cc-video-sound]');
      function attach() {
        if (v.getAttribute('src')) return;
        /* Adaptive HLS stream where the browser plays it natively (lighter on mobile data), else the mp4. */
        var hls = v.dataset.hls && v.canPlayType('application/vnd.apple.mpegurl');
        var src = hls ? v.dataset.hls : v.dataset.src;
        if (src) {
          v.src = src;
          v.preload = 'auto';
        }
      }
      function play() {
        attach();
        var p = v.play();
        if (p && p.catch) p.catch(function () {});
      }
      v.addEventListener('playing', function () { if (box) box.classList.add('is-playing'); });
      if (snd) {
        snd.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var on = v.muted;
          v.muted = !on;
          snd.setAttribute('aria-pressed', on ? 'true' : 'false');
          play();
        });
      }
      if (reduce || saveData) {
        /* No autoplay: tapping the sound button starts it. */
        if (snd) snd.querySelector('.cc-gvideo__sound-off').textContent = 'Spela med ljud';
        return;
      }
      if (!('IntersectionObserver' in window)) { play(); return; }
      new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting && e.intersectionRatio > 0.25) play();
          else if (!v.paused) v.pause();
        });
      }, { threshold: [0, 0.25, 0.6] }).observe(v);
    });
  }
  if (document.readyState === 'complete') {
    setTimeout(initTopVideo, 300);
  } else {
    window.addEventListener('load', function () { setTimeout(initTopVideo, 300); });
  }

  /* "Passar för" chip: open the "Passar produkten dig?" accordion before jumping to it. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('[data-cc-fit-open]');
    if (!a) return;
    var d = document.getElementById('cc-fit');
    if (d) d.open = true;
  });

  /* ---------- Round 10 (D27): Swedish labels for the Slick carousel arrows ---------- */
  /* Slick's default (visually hidden) arrow text is English, "Previous"/"Next", and screen readers read it.
     This file runs (deferred) before the sections start their sliders on DOMContentLoaded, so every slider
     gets Swedish default arrows. A slider that passes its own prevArrow/nextArrow keeps them. A sweep after
     load relabels any default arrow that was created before this ran. */
  var SV_PREV = '<button class="slick-prev" aria-label="Föregående" type="button">Föregående</button>';
  var SV_NEXT = '<button class="slick-next" aria-label="Nästa" type="button">Nästa</button>';
  function svArrows() {
    var $ = window.jQuery;
    if (!$ || !$.fn || !$.fn.slick || $.fn.slick.ccSv) return;
    var orig = $.fn.slick;
    var patched = function (opt) {
      if (opt === undefined || (opt && typeof opt === 'object')) {
        var args = Array.prototype.slice.call(arguments);
        args[0] = $.extend({ prevArrow: SV_PREV, nextArrow: SV_NEXT }, opt || {});
        return orig.apply(this, args);
      }
      return orig.apply(this, arguments);
    };
    patched.ccSv = true;
    $.fn.slick = patched;
  }
  function svSweep() {
    var map = { Previous: 'Föregående', Next: 'Nästa' };
    document.querySelectorAll('.slick-prev, .slick-next').forEach(function (b) {
      var label = b.getAttribute('aria-label');
      if (map[label]) b.setAttribute('aria-label', map[label]);
      var text = (b.textContent || '').trim();
      if (map[text] && b.children.length === 0) b.textContent = map[text];
    });
  }
  svArrows();
  document.addEventListener('DOMContentLoaded', svArrows);
  window.addEventListener('load', function () { svArrows(); svSweep(); setTimeout(svSweep, 3000); });
})();
